import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
import { fetchService } from "./API";

class AMCService extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
        size: 10,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_amcservicename",
        header: "AMC Service Name",
        size: 300,
      },
    ],

    rows: [{ bint_srno: 1, vac_amcservicename: "AMC Service 1" }],
    formData: {
      bint_srno: 0,
      txtAMCServiceName: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "AMC Service");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveAMCService,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtAMCServiceName,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_amcservicename"]);
    const bint_srno = row.bint_srno,
      txtAMCServiceName = row.vac_amcservicename;
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtAMCServiceName,
      },
    });
    document.getElementById("txtAMCServiceName").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_amcservicename"]);
    this.DeleteData(row.bint_srno, row.vac_amcservicename);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListService",
    };
    fetchService(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.ServiceList || [],
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("txtAMCServiceName").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          txtAMCServiceName: "",
        },
      },
      () => {
        document.getElementById("txtAMCServiceName").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationAMCService = () => {
    let result = false;
    if (this.state.formData.txtAMCServiceName.length <= 0) {
      this.props.toastErrorMsg("Enter AMC Service Name", "txtAMCServiceName");
    } else {
      result = true;
    }
    return result;
  };

  saveAMCService = () => {
    this.trimFormData(() => {
      if (this.validationAMCService()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveService",
          bint_srno: this.state.formData.bint_srno,
          vac_amcservicename: this.state.formData.txtAMCServiceName,
        };
        fetchService(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (res.data.ServiceList && res.data.ServiceList.length > 0) {
                rows = res.data.ServiceList;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save AMC Service.", error);
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_amcservicename) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_amcservicename} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteAMCService(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteAMCService = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteService",
      bint_srno: bint_srno,
    };
    fetchService(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.ServiceList && res.data.ServiceList.length > 0) {
            rows = res.data.ServiceList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete AMC Service. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveAMCService}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtAMCServiceName,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="txtAMCServiceName"
              label="AMC Service Name*"
              value={this.state.formData.txtAMCServiceName}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.saveAMCService}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("AMC Service")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={30}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <AMCService {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
